import { put, call, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../../constants';
import { AxiosService } from '../../../services';
import { actionTypes } from '../../../types';
import { viewUGCContentforInfluencerFailure, viewUGCContentforInfluencerSuccess } from '../../actions/InfluencerCampaignActions/viewUGCContentforInfluencerAction';

function* viewUGCContentforInfluencer({ payload, callback }) {
    try {
        const response = yield call(AxiosService, {
            method: 'post',
            base_url: base_url,
            endPoint: endpoints.viewUGCContentforInfluencer,
            payload: payload,
            isAuth: true,
        });
        console.log('====================================');
        console.log("VIEW_UGC_CONTENT_FOR_INFLUENCER_SUCCESS status :", response.data.status);
        console.log("VIEW_UGC_CONTENT_FOR_INFLUENCER_SUCCESS data :", response.data.response);
        console.log("VIEW_UGC_CONTENT_FOR_INFLUENCER_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            viewUGCContentforInfluencerSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
        if (callback) {
            callback(
                response?.data?.status,
                response?.data?.response,
                response?.data?.message
            ); // Pass the response data to the callback
        }
    } catch (error) {
        console.log('====================================');
        console.log("VIEW_UGC_CONTENT_FOR_INFLUENCER_FAILURE status :", error?.response?.status);
        console.log("VIEW_UGC_CONTENT_FOR_INFLUENCER_FAILURE data:", error?.response?.data);
        console.log("VIEW_UGC_CONTENT_FOR_INFLUENCER_FAILURE error :", error);
        console.log('====================================');
        yield put(viewUGCContentforInfluencerFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
    }
}

function* viewUGCContentforInfluencerSaga() {
    yield takeLatest(actionTypes.VIEW_UGC_CONTENT_FOR_INFLUENCER_REQUEST, viewUGCContentforInfluencer);
}

export default viewUGCContentforInfluencerSaga;
